import { render, staticRenderFns } from "./OperationConfigBook.vue?vue&type=template&id=370b5f28&scoped=true"
import script from "./OperationConfigBook.vue?vue&type=script&lang=js"
export * from "./OperationConfigBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370b5f28",
  null
  
)

export default component.exports